export const LoadingSpinnerIcon = () => {
  const commonStyle = {
    animation: 'spinnerAnimation 2s cubic-bezier(0.36, 0.6, 0.31, 1) infinite',
  };

  return (
    <>
      <style>
        {`
          @keyframes spinnerAnimation {
            0% { r: 0; }
            25% { r: 3px; cx: 4px; }
            50% { r: 3px; cx: 12px; }
            75% { r: 3px; cx: 20px; }
            100% { r: 0; cx: 20px; }
          }
        `}
      </style>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          style={{ ...commonStyle }}
          cx="4"
          cy="12"
          r="3"
          fill="white"
        />
        <circle
          style={{ ...commonStyle, animationDelay: '-0.5s' }}
          cx="4"
          cy="12"
          r="3"
          fill="white"
        />
        <circle
          style={{ ...commonStyle, animationDelay: '-1s' }}
          cx="4"
          cy="12"
          r="3"
          fill="white"
        />
        <circle
          style={{ ...commonStyle, animationDelay: '-1.5s' }}
          cx="4"
          cy="12"
          r="3"
          fill="white"
        />
      </svg>
    </>
  );
};
